module.exports = function() {
  return new Worker(__webpack_public_path__ + "46079a3ed91e4cef0a6a.worker.js");
};